<script>
    /**
     * Coloured badge for a supplier's cancellation deadline: "in 4 days" / "in 1 month" / "Passed · 3 days ago",
     * coloured by urgency, with the exact date (and start date when known) on hover.
     * Renders a muted dash when the row has no usable deadline.
     */
    import { t, locale, formatRelativeDays, formatDate } from '../../i18n';
    import { describeDeadline, LEVEL_STYLE } from '../../class/business/Deadlines';

    export let deadline = null;   // [date_start, date_end] from the server, may be null / missing
    export let showDate = false;  // also print the exact end date next to the badge

    $: info  = describeDeadline(deadline);
    $: style = info ? LEVEL_STYLE[info.level] : null;
    $: tooltip = info
        ? $t('deadlines.tooltip', { date: formatDate(info.end, $locale) }) + (info.start ? $t('deadlines.tooltip_since', { date: formatDate(info.start, $locale) }) : '')
        : '';
</script>

<style>
    .deadline-badge { white-space: nowrap; cursor: help; font-weight: 500; }
    .deadline-badge i { font-size: 1.05em; margin-right: 0.15rem; }
</style>

{#if info}
    <span class="badge {style.badge} deadline-badge" data-level={info.level} title={tooltip} aria-label={tooltip}>
        <i class="{style.icon} align-middle"></i>
        {#if info.level === 'passed'}{$t('deadlines.passed')} · {/if}{formatRelativeDays(info.days, $locale)}
    </span>
    {#if showDate}<small class="text-muted ml-50">{formatDate(info.end, $locale)}</small>{/if}
{:else}
    <span class="text-muted" title={$t('deadlines.none')}>–</span>
{/if}
